import type { MStatChipProps } from "../MStatChip/MStatChip.props";

export type MStatChipItem = MStatChipProps;

export interface MStatChipBarProps {
  ariaLabel: string;
  items?: MStatChipItem[];
  bare?: boolean;
  /** When set, the bar manages button chip selection and exposes v-model. */
  selectionMode?: "single" | "multiple";
  /** Labels of currently selected chips — use with v-model. */
  modelValue?: string[];
}

export const mStatChipBarDefaults = {
  bare: false,
} satisfies Partial<MStatChipBarProps>;
